export const READING_GUIDELINES = {
  "Reading & Writing: Fill in the Blanks":
    "Below is a text with blanks. Click on each blank, a list of choices will appear. Select the appropriate answer choice for each blank.",
  "Multiple Choice, Multiple Answers":
    "Read the text and answer the question by selecting all the correct responses. You will need to select more than one response.",
  "Re-order Paragraphs":
    "The text boxes in the have been placed in random order. Restore the original order by dragging the text boxes up or down inside the panel.",
  "Reading: Fill in the Blanks":
    "In the text below some words are missing. Drag words from the box below to the appropriate place in the text. To undo an answer choice, drag the word back to the box below the text or drag thw word into another blank place.",
  "Multiple Choice, Single Answer":
    "Read the text and answer the multiple-choice question by selecting the correct response. Only one response is correct.",
};

export const END_MODAL_SENTENCES = [
  "Please wait while your result is being processed",
  "Compiling your result ...",
  "Almost there ...",
  "Adding final touches ...",
];
